import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';


class SatelliesSideBar extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            isACtive: false,
            routeArray:[
                {routeName:'Profile',linkTo:'/profile-satellite-view'},
                {routeName:' Partner Events',linkTo:'/satellite-adminview'},
            
            ],
            currPath:'' 
        };
    
        // This binding is necessary to make `this` work in the callback
        this.navClick = this.navClick.bind(this);
    }
    
    navClick() {
        this.setState(state => ({
            isACtive: !state.isACtive
        }));
    }

    changeRouter = (e) => {
        this.setState({ currPath: e })
    }

    componentDidMount() {
        if(this.props.router.pathname == '/profile-satellite-view' || this.props.router.pathname == '/satellite-adminview'){
            this.setState({
                currPath:this.props.router.pathname
            })
        }
        else{
            this.setState({
                currPath:'/profile-satellite-view'
            })
        }

    }
    
    
    render() {
        // const currPath = this.props.router.pathname;
        
        return (
            <div className="left_side_wrapper">
               
                {/* <ul> */}
                <ProSidebar >
                    <Menu iconShape="square" active={true}>
                    {/* <li> <Link to='/profile-partner-view'>Profile</Link> </li>
                    <li onClick={this.navClick} className={`has-innerlist ${this.state.isACtive ? "active" : ""}`}>
                        <Link to='/partner-adminview'>Partner Page</Link> */}
                        {/* <ul>
                            <li> <Link to='/profile-partner-view'>inner link 1</Link> </li>
                            <li> <Link to='/profile-partner-view'>inner link 2</Link> </li>
                        </ul> */}
                    {/* </li> */}
                    {/* {this.state.routeArray.map((item)=>(
                            <li>
                                <Link 
                                    to={item.linkTo}
                                    className={currPath === item.linkTo ? 'active' : ''}>{item.routeName}</Link> 
                            </li>
                        ))} */}

                        <MenuItem active={'/profile-satellite-view' === this.state.currPath ? true : false}>
                            <Link onClick={this.changeRouter.bind(this, '/profile-satellite-view')} to='/profile-satellite-view' >Profile</Link>
                        </MenuItem>
                        <MenuItem active={'/satellite-adminview' === this.state.currPath ? true : false}>
                            <Link onClick={this.changeRouter.bind(this, '/satellite-adminview')} to='/satellite-adminview' > Partner Events</Link>
                        </MenuItem>
                        </Menu>
                </ProSidebar>


                {/* </ul> */}
                   
            </div>
        )
    }
}
export default SatelliesSideBar;
